import mixpanel from "mixpanel-browser";
import { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router";

import { handleSubscribe } from "../../api/Billing";
import { UNLIMITED_PRICE_ID_MONTHLY } from "../../constants";
import { useAccount } from "../../hooks/use-account";
import FullScreenLoading from "../common/loading/FullScreenLoading";
import { DSButton } from "../design-system/molecules";

function initiateCheckout(hasInitiated, setCheckoutFailed) {
  hasInitiated.current = true;
  setCheckoutFailed(false);
  mixpanel.track("Upgrade Plan Clicked", {
    featureName: "Direct Link",
  });
  handleSubscribe({
    priceId: UNLIMITED_PRICE_ID_MONTHLY,
    route: "/dashboard",
    onError: () => {
      hasInitiated.current = false;
      setCheckoutFailed(true);
    },
  });
}

export default function UpgradePlan() {
  const { isSubscribed, accountReady } = useAccount();
  const hasInitiated = useRef(false);
  const [checkoutFailed, setCheckoutFailed] = useState(false);

  useEffect(() => {
    if (!accountReady) return;
    if (!hasInitiated.current && !isSubscribed) {
      initiateCheckout(hasInitiated, setCheckoutFailed);
    }
  }, [isSubscribed, accountReady]);

  if (isSubscribed) {
    return <Navigate to="/dashboard" replace />;
  }

  if (checkoutFailed) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-4">
        <p className="text-secondary">
          Something went wrong starting checkout.
        </p>
        <DSButton
          onClick={() =>
            initiateCheckout(hasInitiated, setCheckoutFailed)
          }
        >
          Try Again
        </DSButton>
      </div>
    );
  }

  return <FullScreenLoading loadingTrigger={!accountReady} />;
}
